import React from 'react';
import './App.css';
import Body from './components/Body';

const App = () => <Body {...this.state} />;

export default App;



// WEBPACK FOOTER //
// ./src/App.js